import { Component, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface JobRow {
    job: string
    jobName: string
    invoiceCount: number
    lineCount: number
    spend: number
    topCategories: string
    reason: string
}

interface UnmatchedJobRow {
    text: string
    invoiceCount: number
    lineCount: number
    spend: number
}

@Component({
    selector: 'app-purchased-materials-jobs',
    templateUrl: './purchased-materials-jobs.component.html',
    standalone: true,
    imports: [
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsJobsComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)

    jobGrid: Grid<JobRow>
    unmatchedGrid: Grid<UnmatchedJobRow>

    constructor() {
        super()
        this.jobGrid = new Grid<JobRow>(this.services).wrapColumnHeaders()
        this.unmatchedGrid = new Grid<UnmatchedJobRow>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, true),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    private clear() {
        this.jobGrid.items = []
        this.unmatchedGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            'jobs',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetJobs', filters))
                .subscribe({
                    next: result => {
                        const payload = result[0]
                        this.jobGrid.items = payload.jobs ?? []
                        this.unmatchedGrid.items = payload.unmatched ?? []
                    },
                }),
        )
    }
}
